import { FontInfo } from '@/hooks/use-load-fonts/typings';

const font: FontInfo = {
	name: 'AvenirNext-Bold',
	weight: '700',
	style: 'normal',
	css: (remoteUrl?: string) => `@font-face {
        font-family: 'AvenirNext';
        src: url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/AvenirNextW1G/AvenirNextW1G-Bold.eot');
        src: url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/AvenirNextW1G/AvenirNextW1G-Bold?#iefix') format('embedded-opentype'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/AvenirNextW1G/AvenirNextW1G-Bold.woff2') format('woff2'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/AvenirNextW1G/AvenirNextW1G-Bold.woff') format('woff'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/AvenirNextW1G/AvenirNextW1G-Bold.ttf') format('truetype'),
            url('${remoteUrl ?? ''}/modules/jlr-fonts/latest/AvenirNextW1G/AvenirNextW1G-Bold.svg#AvenirNext') format('svg');
        font-style: normal;
        font-weight: 700;
        font-display: swap;
    }`,
};

export default font;
